import ExamRepository from "@/repositories/tuevs/ExamRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'exams',
    namespaced: true,
    state: {
        ...makeState(),
        listByType: [],
        examMethods: [],
        examPossibleSpecimens: []
    },
    getters: {
        ...makeGetters(),
        allByType(state) {
            return state.listByType
        },
        allMethods(state) {
            return state.examMethods
        },
        allPossibleSpecimens(state) {
            return state.examPossibleSpecimens
        }
    },
    mutations: {
        ...makeMutations(),
        setAllSelect (state, array) {
            state.select_list = array
        },
        updateExam (state, {id, field, value}) {
            state.list = state.list.map(e => {
                if (e.id === id){ e[field] = value }
                return e
            })
        },
        setAllByType(state, array) {
            state.listByType = array
        },
        setAllMethods (state, array) {
            state.examMethods = array
        },
        setAllPossibleSpecimens (state, array) {
            state.examPossibleSpecimens = array
        }
    },
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await ExamRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.exam)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit, state }, params) {
            commit('setLoading', true)
            await ExamRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data)
                const paginator = {
                    page: params && params.page ? params.page : state.pagination.page,
                    per_page: params && params.per_page ? params.per_page : state.pagination.per_page,
                    total: response.data.total
                }
                commit('setPagination', paginator)
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await ExamRepository.fetchAll(params).then(response => {
                if (response.data.data.length > 0){
                    const array = response.data.data
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        },
        async findByType ({ commit }, params) {
            commit('setLoading', true)
            await ExamRepository.findByType(params).then(response => {
                commit('setAllByType', response.data)
            })
            commit('setLoading', false)
        },
        async listMethods ({ commit }, id) {
            commit('setLoading', true)
            await ExamRepository.fetchMethods(id).then(response => {
                commit('setAllMethods', response.data.data)
            })
            commit('setLoading', false)
        },
        async listPossibleSpecimens ({ commit }, id) {
            commit('setLoading', true)
            await ExamRepository.fetchPossibleSpecimens(id).then(response => {
                commit('setAllPossibleSpecimens', response.data.data || [])
            })
            commit('setLoading', false)
        }
    }
}
